import React from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useDivision } from "@/context/DivisionContext";

const ProjectInfoForm = ({ projectInfo, onChange }) => {
  const { getCountyLabel } = useDivision();
  
  const handleChange = (field, value) => {
    onChange({ ...projectInfo, [field]: value });
  };

  return (
    <Card className="millmetrix-card p-6" data-testid="project-info-form">
      <div className="section-header">
        <h3 className="text-xl font-semibold tracking-tight uppercase text-muted-foreground">
          Project Information
        </h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <Label htmlFor="county" className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            {getCountyLabel()}
          </Label>
          <Input
            id="county"
            data-testid="county-input"
            type="text"
            value={projectInfo.county}
            onChange={(e) => handleChange('county', e.target.value.toUpperCase())}
            className="millmetrix-input uppercase mt-2"
            placeholder="e.g., BELL"
          />
        </div>
        
        <div>
          <Label htmlFor="highway" className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            Highway/Roadway
          </Label>
          <Input
            id="highway"
            data-testid="highway-input"
            type="text"
            value={projectInfo.highway}
            onChange={(e) => handleChange('highway', e.target.value.toUpperCase())}
            className="millmetrix-input uppercase mt-2"
            placeholder="e.g., US 190"
          />
        </div>
        
        <div>
          <Label htmlFor="control_number" className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            Control Number
          </Label>
          <Input
            id="control_number"
            data-testid="control-number-input"
            type="text"
            value={projectInfo.control_number}
            onChange={(e) => handleChange('control_number', e.target.value.toUpperCase())}
            className="millmetrix-input uppercase mt-2"
            placeholder="e.g., 6479-53-001"
          />
        </div>
        
        <div className="md:col-span-2">
          <Label htmlFor="letting_date" className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            Letting Date
          </Label>
          <Input
            id="letting_date"
            data-testid="letting-date-input"
            type="date"
            value={projectInfo.letting_date}
            onChange={(e) => handleChange('letting_date', e.target.value)}
            className="millmetrix-input mt-2"
          />
        </div>
      </div>
    </Card>
  );
};

export default ProjectInfoForm;
